import React, { useContext, useEffect } from 'react'
import Slider from 'react-slick'
import HomeBlogCard from '../Cards/HomeBlogCard'
import { HrStorage } from '../../Context/HrStore'
import { motion } from 'framer-motion'

const OurBlogs = () => {
    let { allblog, getallblog } = useContext(HrStorage)
    let settings = {
        dots: false,
        arrows: false,
        speed: 2000,
        slidesToShow: 3,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToScroll: 1,
        initialSlide: 0,
        infinite: true,
        responsive: [
            {
                breakpoint: 1040,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 830,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    }
    useEffect(() => {
        getallblog()
    }, [])

    return (
        <section className="bg-white py-24 relative overflow-hidden">
            {/* Subtle light background element */}
            <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-slate-50/50 blur-[100px] rounded-full -z-0 pointer-events-none" />

            <div className="container mx-auto px-6 relative z-10">
                {/* Header */}
                <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-center mb-16 space-y-4"
                >
                    <p className="text-blue-600 font-bold tracking-[0.3em] text-[10px] uppercase">Case Studies</p>
                    <h2 className="text-3xl md:text-5xl font-bold text-slate-900 syne leading-tight">
                        Our Latest <span className="text-blue-600">Insights</span>
                    </h2>
                    <p className="text-slate-500 text-sm md:text-lg max-w-2xl mx-auto leading-relaxed">
                        Stay updated with the latest trends, tips, and strategies in the HR industry from our expert team.
                    </p>
                </motion.div>

                {/* Slider */}
                <div className="-mx-3">
                    <Slider {...settings} className='py-2 pb-10'>
                        {
                            allblog && [...allblog].reverse().slice(0, 4).map((obj, index) => (
                                <div key={index} className="px-3">
                                    <HomeBlogCard data={obj} /> 
                                </div>
                            ))
                        }
                    </Slider>
                </div>
            </div>
        </section>
    )
}

export default OurBlogs